/* eslint-disable eslint-comments/no-restricted-disable */

import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ProductsJcsCustomerAccessEntryPointComponent = EntryPointComponent<{}, {}, {}, {} | null>;

export const productsJcsCustomerAccessEntryPoint: EntryPoint<
	ProductsJcsCustomerAccessEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<ProductsJcsCustomerAccessEntryPointComponent>(
		/* webpackChunkName: "async-products-jcs-customer-access" */ './ProductsJcsCustomerAccess.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
